import { render, staticRenderFns } from "./ModalChooseItemType.vue?vue&type=template&id=25d19df8&scoped=true"
import script from "./ModalChooseItemType.vue?vue&type=script&lang=js"
export * from "./ModalChooseItemType.vue?vue&type=script&lang=js"
import style0 from "./ModalChooseItemType.vue?vue&type=style&index=0&id=25d19df8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d19df8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25d19df8')) {
      api.createRecord('25d19df8', component.options)
    } else {
      api.reload('25d19df8', component.options)
    }
    module.hot.accept("./ModalChooseItemType.vue?vue&type=template&id=25d19df8&scoped=true", function () {
      api.rerender('25d19df8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalChooseItemType.vue"
export default component.exports